module.exports = __webpack_public_path__ + "img/left.e957bcef.svg";